import moment from 'moment';
import { handleApiOrder } from './';
import { dateFormat } from './../../services/ruleValidate';
import dataRow from './../../containers/orders/components/items/dataRow';

// OrderFromShipment
const OrderFromShipment = (shipment, packages, state) => {
    let itemFromPackage = []

    let shipmentNew = {
        key: 1,
        channel: typeof shipment['ChannelName'] === 'string' ? shipment['ChannelName'].trim() : shipment['ChannelName'],
        channel_id: typeof shipment['ChannelID'] === 'string' ? shipment['ChannelID'].trim() : shipment['ChannelID'],
        channel_order: '',
        channel_short_name: typeof shipment['ChannelShortName'] === 'string' ? shipment['ChannelShortName'].trim() : shipment['ChannelShortName'],
        order_date: moment().format(dateFormat),
        order_date_utc: new Date(),
        ref: typeof shipment['ReferenceNumberCH'] === 'string' ? shipment['ReferenceNumberCH'].trim() : shipment['ReferenceNumberCH'],
        customer: '',
        channel_customer: '',
        name: typeof shipment['ConsigneeNameCH'] === 'string' ? shipment['ConsigneeNameCH'].trim() : shipment['ConsigneeNameCH'],
        yomigana: typeof shipment['ConsigneeKanaNameCH'] === 'string' ? shipment['ConsigneeKanaNameCH'].trim() : shipment['ConsigneeKanaNameCH'],
        phone: typeof shipment['ConsigneePhoneCH'] === 'string' ? shipment['ConsigneePhoneCH'].trim() : shipment['ConsigneePhoneCH'],
        email: typeof shipment['ConsigneeEmailCH'] === 'string' ? shipment['ConsigneeEmailCH'].trim() : shipment['ConsigneeEmailCH'],
        country: typeof shipment['DestinationCountryCH'] === 'string' ? shipment['DestinationCountryCH'].trim() : shipment['DestinationCountryCH'],
        postal_code: typeof shipment['ConsigneePostalCodeCH'] === 'string' ? shipment['ConsigneePostalCodeCH'].trim() : shipment['ConsigneePostalCodeCH'],
        address1: typeof shipment['ConsigneeAddress1CH'] === 'string' ? shipment['ConsigneeAddress1CH'].trim() : shipment['ConsigneeAddress1CH'],
        address2: typeof shipment['ConsigneeAddress2CH'] === 'string' ? shipment['ConsigneeAddress2CH'].trim() : shipment['ConsigneeAddress2CH'],
        address3: typeof shipment['ConsigneeAddress3CH'] === 'string' ? shipment['ConsigneeAddress3CH'].trim() : shipment['ConsigneeAddress3CH'],
        address4: typeof shipment['ConsigneeAddress4CH'] === 'string' ? shipment['ConsigneeAddress4CH'].trim() : shipment['ConsigneeAddress4CH'],
        address_type: typeof shipment['AddressType'] === 'string' ? shipment['AddressType'].trim() : shipment['AddressType'],
        terms: typeof shipment['PaymentTermCH'] === 'string' ? shipment['PaymentTermCH'].trim() : shipment['PaymentTermCH'],
        preferred_time: typeof shipment['DeliveryTimeCH'] === 'string' ? shipment['DeliveryTimeCH'].trim() : shipment['DeliveryTimeCH'],
        currency: typeof shipment['CurrencyCH'] === 'string' ? shipment['CurrencyCH'].trim() : shipment['CurrencyCH'],
        FulfillmentOption: typeof shipment['FulfillmentOption'] === 'string' ? shipment['FulfillmentOption'].trim() : shipment['FulfillmentOption'],
        CollectAmount: shipment['CollectAmount'],
        Remark: shipment['Remark'],
    }

    itemFromPackage.push(dataRow())

    let result = handleApiOrder(shipment, shipmentNew, itemFromPackage, state)

    return {
        shipmentNew: result.informationFill,
        itemFromPackage: result.itemsFill,
        state: result.state
    }
}

export default OrderFromShipment



// WEBPACK FOOTER //
// ./src/reducers/helper/helperAddOrderFromShipment.js